import { NgModule } from '@angular/core';
import {NotFoundComponent} from "./not-found.component";

@NgModule({
  imports: [
  ],
  declarations: [NotFoundComponent]
})
export class NotFoundModule { }
